import React from "react";
import { Link } from "react-router-dom";

const QuizEditor = () => {
	return (
		<div>
			<div className="row quizeditor">
				<div className="col-lg-3 col-sm-6 ">
					<div className="card-box bg-blue">
						<div className="inner">
							<h3>Upload Quiz</h3>
							<p>Upload Quiz to Multiple Courses</p>
						</div>
						<div className="icon">
							<i className="fa fa-money" aria-hidden="true"></i>
						</div>
						<Link
							className="card-box-footer"
							to="/quiz-form-edit/creating-an-quiz-exam"
						>
							Open
							<i className="fa fa-arrow-circle-right"></i>
						</Link>
					</div>
				</div>
				<div className="col-lg-3 col-sm-6">
					<div
						className="card-box bg-green
          "
					>
						<div className="inner">
							<h3>Edit Quiz</h3>
							<p>Edit Course Specific Quiz</p>
						</div>
						<div className="icon">
							<i className="fa fa-money" aria-hidden="true"></i>
						</div>
						<Link
							className="card-box-footer"
							to="/quiz-form-edit/edit-quiz"
						>
							Open
							<i className="fa fa-arrow-circle-right"></i>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default QuizEditor;
